/* eslint-disable tailwindcss/no-custom-classname */
import { FunctionComponent, ReactElement } from 'react'

interface Props {
  data: { label: ReactElement; value: ReactElement | string }[]
}

export const Statistics: FunctionComponent<Props> = ({ data }) => {
  return (
    <div className="flex flex-col">
      {data.map(({ label, value }, index) => (
        <div
          className="flex items-center justify-between gap-6 py-3"
          key={index}
          style={{ borderTop: index === 0 ? 'none' : '1px solid var(--rule-light)' }}
        >
          <div className="rng-labelcaps flex items-center">{label}</div>
          <div className="text-right tabular-nums" style={{ color: 'var(--ink)', fontSize: 13 }}>
            {value}
          </div>
        </div>
      ))}
    </div>
  )
}
